<template>
    <div style="padding-top:-2px;margin-top:-2px;">
        <template v-if="checkList == false">
            <v-label>
                <b>{{ label }}</b>
            </v-label>
            <s-select-generic
                ref="sgeneric"
                style="margin-top:0px;"
                :config="config"
                :disabled="disabled"
                itemvalue="CumId"
                :clearable="clearable"
                :itemtext="abbr ? 'CumNombre' : 'CumNombre'"
                :id="id"
                :noDefault="clearable"
                :value="valueLocal"
                @input="input($event)"
                :returnObject="returnObject"
                :add="add"
                @add="addEvent()"
               >
            </s-select-generic>
        </template>

        <!-- <div v-if="check">
            <v-label>
                <b>{{ label }}</b>
            </v-label>
            <v-checkbox
                hide-details=""
                v-for="(item, i) in items"
                :value="item[id]"
                :disabled="disabled"
                :readonly="readonly"
                v-model="selected"
                :label="abbr ? item.CumNombre : item.CumNombre"
                :key="i"
            />
        </div>  -->

        <div v-if="checkList">
      
        <v-select multiple :items="items" v-model="selected" :returnObject="returnObject" :clearable="clearable" item-value="CumId" :label="label" item-text="CumNombre">
        
        </v-select>
    </div>

    <v-dialog v-model="dialogAdd" v-if="dialogAdd" width="500" persistent>
      <v-card>
        <v-toolbar dark flat dense elevation="0" color="primary">
          <v-toolbar-title>Agregar Cliente</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogAdd = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-container>
          <v-row>
            <v-col cols="12">
              <s-text
                label="Nombre"
                v-model="newClient.CumNombre"
                ref="txtClientName"
              ></s-text>
            </v-col>
            <v-col cols="12" md="6">
              <s-select-definition
                label="Cultivo"
                v-model="newClient.CumCultivo"
                :def="1173"
              ></s-select-definition>
            </v-col>
            <v-col cols="12" md="6">
              <s-text
                label="Código SAP"
                v-model="newClient.CumCodigoSap"
              ></s-text>
            </v-col>
            <v-col cols="12">
              <s-select-definition
                label="Estado"
                v-model="newClient.CumState"
                :def="1415"
              ></s-select-definition>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogAdd = false">Cancelar</v-btn>
          <v-btn color="success" text @click="saveClient()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
    import _sCustomerMaduration from "@/services/FrozenProduction/FrzCustomersMaturationService";

    export default {
        components: {},
        props: 
        {
            id: {
            type: String,
            default: "CumID",
            },
            disabled: {
            type: Boolean,
            default: false,
            },
            clearable: {
            type: Boolean,
            default: false,
            },
            value: null,
            text: { type: String, default: "" },
            label: {
            type: String,
            default: "",
            },
            abbr: {
            type: Boolean,
            default: false,
            },
            returnObject: {
            type: Boolean,
            default: false,
            },
            produceID:{
            type: Number,
            default: 0,
            },
            position:{
            type: Number,
            default: 0,
            },
            noDefault: {
            type: Boolean,
            default: false,
            },    
            full: {
            type: Boolean,
            default: false,
            },
            checkList: {
            type: Boolean,
            default: false,
            },
            add: {
            type: Boolean,
            default: false,
            },
        },
        watch: {
            value(value) {
                this.item = value;

                this.valueLocal=this.value;
            },
            produceID(){
                this.config.params.SpvId=this.produceID
            },
            selected(value) {

            let f = this.items.find((x) => x[this.id] == value);
            if (!this.returnObject) this.$emit("input", value);
            else this.$emit("input", f);
            },
            dialogAdd(newValue) {
                if (newValue === false) {
                    this.refreshGeneric();
                }
            },
        },
        methods:{
            input(val){
                this.$emit("input", val);
            },
            addEvent() {
                this.resetNewClient();
                this.dialogAdd = true;
            },
            refreshGeneric() {
                const ref = this.$refs.sgeneric;
                if (ref) {
                    if (Array.isArray(ref)) {
                        ref.forEach(function (r) { if (r && typeof r.load === 'function') r.load(); });
                    } else if (typeof ref.load === 'function') {
                        ref.load();
                    }
                }
            },
            resetNewClient() {
                this.newClient = {
                    CumNombre: '',
                    CumCultivo: 0,
                    CumCodigoSap: '',
                    CumState: 0,
                };
            },
            saveClient() {
                if (!this.newClient.CumNombre || this.newClient.CumNombre.trim() === '') {
                    this.$fun.alert("Ingrese el nombre del cliente", "warning");
                    return;
                }
                const self = this;
                const item = {
                    CumId: 0,
                    CumNombre: this.newClient.CumNombre,
                    CumCultivo: this.newClient.CumCultivo,
                    CumCodigoSap: this.newClient.CumCodigoSap,
                    CumState: this.newClient.CumState,
                    SecStatus: 1,
                    UsrCreateID: this.$fun.getUserID(),
                    UsrUpdateID: this.$fun.getUserID(),
                };
                _sCustomerMaduration.save(item, this.$fun.getUserID()).then(function (r) {
                    if (r.status == 200) {
                        self.$fun.alert("Cliente agregado correctamente", "success");
                        self.dialogAdd = false;
                        self.refreshGeneric();
                        // Select the newly created client
                        self.$nextTick(function () {
                            if (r.data && r.data.CumId) {
                                self.valueLocal = r.data.CumId;
                                self.$emit("input", r.data.CumId);
                            }
                        });
                    }
                }).catch(function (error) {
                    console.error("Error al guardar cliente:", error);
                    self.$fun.alert("Error al guardar el cliente", "error");
                });
            },
        },
        data: () => ({
            item: 0,
            val: "",
            items: [],
            config: {},
            selected: [],
            valueLocal:null,
            dialogAdd: false,
            newClient: {
                CumNombre: '',
                CumCultivo: 0,
                CumCodigoSap: '',
                CumState: 0,
            },
        }),
        created(){

            this.config = {
                url: _sCustomerMaduration.getUrlListClientMaturation(),
                title: this.label,
                params: { search: "", requestID: this.$fun.getUserID(), SpvId: this.position}
            };

            if(this.checkList)
            {          
           
                this.$http
                .post(
                    _sCustomerMaduration.getUrlListClientMaturation(),
                    {},
                    {
                    params: this.config.params,
                    }
                )
                .then((r) => {
                    if (r.status == 200) {
                    this.items = r.data;
                    this.$emit("getDataInitial", this.items);
                    }
                });
            }
        },
    };
</script>